import { useContext } from "react";
import Button from "../../components/ui/button/Button";
import LicencePlate from "../../components/ui/licence_plate/LicencePlate";
import NavButton from "../../components/ui/navbutton/NavButton";
import styles from "./styles/Search.module.css";
import DataContext from "../../context/DataContext";
import { useTranslation } from "react-i18next";

const PlatePanel = ({ responseData }) => {
    const { homePath } = useContext(DataContext);
    const { t } = useTranslation();
    return (
        <>
            <div
                className={`${styles.float_search_button_container} v-flex-container`}
            >
                <NavButton
                    body={t(`new search`)}
                    size={"small"}
                    link={homePath}
                />
            </div>
            <div className={`${styles.float_plate_container} flex-container`}>
                <LicencePlate
                    // margin={"1rem 0 0 0 "}
                    // country={"D"}
                    number={
                        responseData?.ticket?.plate
                            ? responseData?.ticket?.plate
                            : responseData?.settlements?.[0]?.plate
                              ? responseData?.settlements?.[0]?.plate
                              : responseData?.relatedTickets?.[0]?.plate
                    }
                />
            </div>
        </>
    );
};

export default PlatePanel;
